import CaretIcon from '@bfly/icons/Caret';
import styled from 'astroturf';
const Caret = /*#__PURE__*/styled(CaretIcon, null, {
  displayName: "Caret",
  styles: require("./Caret.module.scss"),
  attrs: null,
  vars: []
});
export default Caret;